export default __webpack_public_path__ + "static/media/Datorsal1.1caff258.jpeg";